import { useMutation, useQueryClient } from "@tanstack/react-query";
// API
import API from "./Api";

export default function useAddImageTaxiOrderApi() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, images }) => {
      const formData = new FormData();
      images.forEach((file) => {
        formData.append("images[]", file);
      });

      const { data } = await API.post(`api/taxi-orders/add-image/${id}`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["AllTaxiOrders"] }); // ← adjust key to match your getAll hook's query key
    },
  });
}
